export default __webpack_public_path__ + "static/media/blackslider4.81be0cf9.png";